var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.887 10.17c0-.742-.06-1.284-.19-1.845h-8.47v3.348H14.2c-.1.832-.642 2.084-1.844 2.926l-.017.112 2.677 2.075.186.018c1.704-1.573 2.686-3.889 2.686-6.635",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.227 18.99c2.436 0 4.48-.803 5.974-2.186L12.354 14.6c-.761.531-1.783.902-3.127.902-2.385 0-4.41-1.573-5.131-3.748l-.106.009-2.784 2.155-.037.1a9.01 9.01 0 0 0 8.058 4.972",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.096 11.753a5.6 5.6 0 0 1-.3-1.784c0-.622.11-1.223.29-1.784l-.005-.12-2.82-2.19-.092.045a9 9 0 0 0-.962 4.049c0 1.453.35 2.826.962 4.049z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.227 4.436c1.694 0 2.837.732 3.488 1.343l2.546-2.485C13.698 1.84 11.663.949 9.227.949a9.01 9.01 0 0 0-8.058 4.97l2.917 2.266c.732-2.175 2.756-3.749 5.141-3.749",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .949h18.103v18.103H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.0bd4d2ec1b0d8c43a03434af84de45a5.svg";
export { ForwardRef as ReactComponent };